// Task 13 (WU-2.3) — one home for the "Send note" client affordance gate so
// LiveRoster/OperatorGrid/BatchDetailPage don't each inline the same
// admin-OR-cap expression. Cosmetic only — the server is authoritative on
// supervisor.direct_note; this only decides whether to render the button.
export function canSendDirectNote(user: { permissions?: string[] } | null | undefined): boolean {
  return !!user?.permissions?.includes("supervisor.direct_note") || !!user?.permissions?.includes("admin");
}
